import React, { useState, useRef, useEffect } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import logo from "./assets/logo-pocr.png";
import gallery from "./assets/gallery.png";
import retake from "./assets/retake.png";
import submit from "./assets/submit.png";
import camera from "./assets/camera.png";
import { imageUploadUrl } from "./configUrls";
import { post } from "axios";
import Loading from "./components/Loader";
import Dialog from "./components/Dialog";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    textAlign: "center",
    paddingTop: "30px",
    overflowY: "auto",
    paddingBottom: "30px"
  },
  imgBox: {
    maxWidth: "80%",
    maxHeight: "45vh",
    margin: "10px auto"
  },
  input: {
    display: "none"
  },
  popup: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: "999",
    width: "300px",
    height: "150px"
  },
  popupContainer: {
    display: "flex",
    width: "100%",

    justifyContent: "center",
    alignItems: "center"
  },
  closebtn: {
    position: "absolute",
    top: "5px",
    left: "5px"
  },

  captureimagetext: {
    marginBottom: "0px",
    color: "#333",
    fontSize: "25px"
  },

  gallery: {
    width: "220px",
    marginTop: "20px",
    borderRadius: "25px",
    color: "white",
    background: "#eb4034",
    border: "none",
    fontWeight: "bold",
    paddingLeft: "60px",
    backgroundImage: `url(${gallery})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "30px 9px",
    backgroundSize: "30px",
    paddingRight: "20px"
  },
  takeimage: {
    width: "220px",
    marginTop: "20px",
    borderRadius: "25px",
    color: "white",
    background: "#eb4034",
    border: "none",

    fontWeight: "bold",
    paddingLeft: "60px",
    backgroundImage: `url(${camera})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "20px 9px",
    backgroundSize: "30px",
    paddingRight: "20px"
  },
  retake: {
    width: "185px",
    marginTop: "20px",
    borderRadius: "25px",
    color: "white",
    background: "#eb4034",
    border: "none",
    fontWeight: "bold",
    paddingLeft: "60px",
    backgroundImage: `url(${retake})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "45px 9px",
    backgroundSize: "30px",
    paddingRight: "20px"
  },
  submit: {
    width: "185px",
    marginTop: "20px",
    borderRadius: "25px",
    color: "white",
    background: "#eb4034",
    border: "none",
    fontWeight: "bold",
    paddingLeft: "60px",
    backgroundImage: `url(${submit})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "45px 9px",
    backgroundSize: "30px",
    paddingRight: "8px"
  },
  wellcome: {
    fontWeight: "bold",
    color: "#000",
    fontSize: "25px",
    marginBottom: "0px"
  },
  uploadimage: {
    marginBottom: "25%",
    fontWeight: "bold"
  },
  logoimage: {
    marginBottom: "18px",
    width: "180px"
  },
}));
function App(props) {
  const classes = useStyles();
  const inputReference = useRef();
  const [source, setSource] = useState("");
  const [reTake, setRetake] = useState(false);
  const [file, setfile] = useState(null);
  const [isShowing, setShowing] = useState(true);
  const [isLoader, setLoader] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [popUpMessage, setPopUpMsg] = useState("");
  const [requestId, setRequestId] = useState("");
  //let idid = new URLSearchParams(window.location.search);
  const handleCapture = (target) => {
    if (target.files) {
      if (target.files.length !== 0) {
        const file = target.files[0];
        const newUrl = URL.createObjectURL(file);
        setSource(newUrl);
        setRetake(false);
        setShowing(false);
        setfile(file);
      }
    }
    target.value = "";
  };
  const fileUploadAction = () => {
    console.log("hie");
    inputReference.current.removeAttribute("capture");
    inputReference.current.removeAttribute("accept");
    inputReference.current.click();
  };

  const cameraHandler = () => {
    console.log("hie");

    inputReference.current.accept = "image/*";
    inputReference.current.capture = "environment";
    inputReference.current.click();
  };
  const retakeImage = () => {
    setRetake(true);
    setShowing(true);
    setSource("");
    setSuccess(false);
  };
  const submitHandler = () => {
    setLoader(true);
    console.log("submit", requestId);
    const data = new FormData();
    data.append("file", file);

    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
      }
    };
    let uploadUrl = `${imageUploadUrl}/fileupload/mobile?requestId=${requestId}`;
    post(uploadUrl, data, config).then(
      (response) => {
        setLoader(false);
        setSuccess(true);
        setPopUpMsg(response.data.message);
        console.log("response12", response);
      },
      (error) => {
        setLoader(false);

        console.log("error", requestId);
      }
    );
  };
  useEffect(() => {
    console.log("use", reTake, source, isShowing);
  }, [reTake, source, isShowing]);
  const closePopuo = () => {
    setSuccess(false);
  };
  useEffect(() => {
    if (
      decodeURIComponent(new URLSearchParams(window.location.href)).split(
        "?"
      )[1]
    ) {
      setRequestId(
        decodeURIComponent(new URLSearchParams(window.location.href))
          .split("?")[1]
          .split("=")[1]
      );
    }

    cameraHandler();
  }, []);

  return (
    <div className={classes.root}>
      {console.log("requestIDDD", requestId)}
      {isLoader && <Loading />}
      {isSuccess && <Dialog closeDialog={closePopuo} text={popUpMessage} />}

      <img src={logo} alt="POCR logo" className={classes.logoimage} />

      {isShowing ? (
        <div className={classes.popupContainer}>
          <div className={`${classes.popup} btn-btn`}>
            <p className={classes.wellcome}>WELLCOME</p>
            <p className={classes.uploadimage}>UPLOAD AN IMAGE TO PROCESS</p>
            <button onClick={cameraHandler} className={classes.takeimage}>
              TAKE A PICTURE
            </button>
            <div>
              <button onClick={fileUploadAction} className={classes.gallery}>
                GALLERY
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {!reTake && source && (
        <Box display="flex" justifyContent="center" className={classes.imgBox}>
          <img src={source} alt={"snap"} className={classes.img} width="250" height='160'></img>
        </Box>
      )}
      {!reTake && source && (
        <div className={classes.retakesubmit}>
          <button onClick={retakeImage} className={classes.retake}>
            Retake
          </button>
          <button onClick={submitHandler} className={classes.submit}>
            Submit
          </button>
        </div>
      )}
      <input
        ref={inputReference}
        className={classes.input}
        id="icon-button-file"
        type="file"
        onChange={(e) => {
          handleCapture(e.target);
          return false;
        }}
        multiple
      />
    </div>
  );
}
export default App;
